import { useQuery } from '@tanstack/react-query';
import axios from 'axios';

function useAssetOwner(assetId, enabled) {
  const ownerQuery = useQuery({
    queryKey: ['assetOwner', assetId],
    queryFn: async () => {
      try {
        const { data } = await axios.get(`https://mainnet-idx.algonode.cloud/v2/assets/${assetId}/balances`);
        return data.balances.filter((balance) => balance.amount > 0)?.[0];
      } catch (error) {
        return null;
      }
    },
    enabled: !!assetId && enabled,
    refetchOnWindowFocus: false,
    refetchOnReconnect: false,
    refetchIntervalInBackground: false,
    staleTime: Infinity,
  });
  const owner = ownerQuery.data || null;

  return owner;
}

export default useAssetOwner;
